// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "@firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAzOe0m69KjZSg9S_mvDInPTFafm1yQhpM",
  authDomain: "bishopcorrie-8aced.firebaseapp.com",
  projectId: "bishopcorrie-8aced",
  storageBucket: "bishopcorrie-8aced.appspot.com",
  messagingSenderId: "632082868086",
  appId: "1:632082868086:web:cc8d202a6b2147b2ce7c57",
  measurementId: "G-4N28DEJR8L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default getFirestore(app);